import routes from '../app/constants/routes'

const clientId = OE_ENV.AUTH_CLIENT_ID
const authorizationServer = OE_ENV.OKTA_AUTH_SERVER

const baseUrl = OE_ENV.OKTA_BASE_URL
const issuer = `${baseUrl}/oauth2/${authorizationServer}`

const authorizeUri = `${issuer}/v1/authorize`
const userinfoUri = `${issuer}/v1/userinfo`

const redirectUri = `${window.location.origin}${routes.IMPLICIT_CALLBACK}`

const scopes = 'openid profile email'
const scopesAsArray = scopes.split(' ')

const responseType = 'id_token token'
const responseTypeAsArray = responseType.split(' ')

const responseMode = 'fragment'

const nonce = 'aaaa'
const state = 'aaaa'

export const createIdpRedirectUri = (idp) => {
  const url = new URL(authorizeUri)

  Object.entries({
    client_id: clientId,
    response_type: responseType,
    response_mode: responseMode,
    scope: scopes,
    redirect_uri: redirectUri.toString(),
    nonce,
    state,
  }).forEach(([key, value]) => url.searchParams.set(key, value))

  return url.toString()
}

const createRedirectParams = () => JSON.stringify({
  responseType: responseTypeAsArray,
  scopes: scopesAsArray,
  urls: {
    issuer: issuer,
    authorizeUrl: authorizeUri,
    userinfoUrl: userinfoUri,
  },
  nonce,
  state,
})

export const createRedirectParamsCookie = () => `okta-oauth-redirect-params=${createRedirectParams()};path=/`

export const createOktaAuthConfig = (history, onAuthRequired) => ({
  history,
  issuer: issuer,
  client_id: clientId,
  redirect_uri: redirectUri.toString(),
  onAuthRequired,
})
